module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "why-mikmak"
  }, [_c('div', {
    staticClass: "whitespace",
    attrs: {
      "id": "whitespace"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "why-mikmak-heading"
  }, [_vm._v("Why MikMak?")]), _vm._v(" "), _c('div', {
    staticClass: "why-mikmak-table"
  }, [_c('div', {
    staticClass: "table-row"
  }, [_c('span', {
    staticClass: "table-column blank"
  }), _vm._v(" "), _c('span', {
    staticClass: "table-column header blank"
  }, [_vm._v("Brands sold at retailers")]), _vm._v(" "), _c('span', {
    staticClass: "table-column header blank"
  }, [_vm._v("DTC Brands")])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('span', {
    staticClass: "table-column legend"
  }, [_c('i', [_vm._v("Problem")]), _vm._v(": User clicks or swipes from media")]), _vm._v(" "), _c('span', {
    staticClass: "table-column"
  }, [_vm._v("No PDP data & no control over experience.")]), _vm._v(" "), _c('span', {
    staticClass: "table-column"
  }, [_vm._v("70-90% of users bounce from site.")])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('span', {
    staticClass: "table-column legend"
  }, [_c('i', [_vm._v("Solution")]), _vm._v(": MikMak Attach")]), _vm._v(" "), _c('span', {
    staticClass: "table-column"
  }, [_vm._v("Connect to retailers like Amazon, Target, Walmart, Kroger, Instacart, CVS and more.")]), _vm._v(" "), _c('span', {
    staticClass: "table-column"
  }, [_vm._v("Connect to your own DTC Cart like Demandware, Shopify, Magento, Hybris and more.")])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('span', {
    staticClass: "table-column legend"
  }, [_c('i', [_vm._v("The MikMak ROI")])]), _vm._v(" "), _c('span', {
    staticClass: "table-column"
  }, [_vm._v("Custom Audiences, 15-200% lift, 25-40% higher ROAS, 1.5X lift in CPA efficiency and 2X lift in CTR.")]), _vm._v(" "), _c('span', {
    staticClass: "table-column"
  }, [_vm._v("Reduce bounce rates by 20%, 20-40% lift in add to cart rate, 1.5X lift in CPA efficiency and 2X lift in CTR.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06c79b62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/WhyMikMak/WhyMikMak.vue
// module id = 450
// module chunks = 0